import styled from 'styled-components'

const RESULTS_MAP_RATIO = 1.61803398875

export const filterBarHeight = '80px'

export const Outerwrapper = styled.div``

export const FilterBarWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  padding: 0 22px;
  width: 100%;
  min-height: ${filterBarHeight};

  & > button:first-child {
    margin-right: 16px;
  }
`

export const ResultsArea = styled.div`
  padding: var(--ds-space-05);
  width: calc(100% / ${RESULTS_MAP_RATIO});
`

export const MapContainer = styled.div`
  height: 100%;
  position: relative;
  background-color: #e1dfda;
`

export const StickyBar = styled.div`
  position: sticky;
  top: 0;
  // If z-index is higher than 1 will obscure mini search dropdown, if lower the
  // filters will not sit above the search results:
  z-index: 1;

  > ${FilterBarWrapper} {
    background-color: white;
    border-bottom: 1px solid #e5e6e4;
  }

  > ${MapContainer} {
    // Make height equal to viewport height less the height of the bar area:
    height: calc(100vh - 100%);
    width: calc(100% - (100% / ${RESULTS_MAP_RATIO}));

    // Position at bottom right of filter-bar:
    position: absolute;
    top: 100%;
    right: 0;

    // Push behind filter bar:
    z-index: -1;
  }
`
